const underConstructionDictEN = {
  comingSoon: 'Coming Soon',
  photoBy: 'Photo by',
}

export default underConstructionDictEN;